export default __webpack_public_path__ + "static/media/navbar-password-dark.86117219.svg";